// extracted by mini-css-extract-plugin
export default {"container":"PL-z","error":"QL-z","disabled":"RL-z","submit":"SL-z","option":"TL-z","success":"UL-z","failure":"VL-z"};